import { DescriptionList } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

const { Label, Description } = DescriptionList

export interface ReferenceIdProps {
  /**
   * The reference ID of the transaction.
   */
  referenceId: string
}

export const ReferenceId: React.FC<ReferenceIdProps> = ({ referenceId }) => {
  const { t } = useTranslation('payments')

  return (
    <>
      <Label>{t('transactionDetail.referenceID')}</Label>
      <Description>{referenceId}</Description>
    </>
  )
}
